import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const useUpdateAssignee = (
  options?: MutationFunctionOptions,
): ((options?: MutationFunctionOptions) => Promise<FetchResult>) => {
  const [updateAssignee] = useMutation(
    gql`
      mutation ($input: AssignGsDecisionInput!) {
        updateGSAssignee(input: $input) {
          applicationId
        }
      }
    `,
    {
      ...options,
    },
  );

  return updateAssignee;
};
